import { defineMessages } from 'react-intl';

import { BillingProductBlockReason } from '@/entities/organization';

export const addPackageBlockReasonMessages =
  defineMessages<BillingProductBlockReason>({
    noPermission: {
      id: 'packages.addNoPermissionTooltip',
      defaultMessage: 'You do not have permission to add a package.',
    },
  });

export const removePackageBlockReasonMessages =
  defineMessages<BillingProductBlockReason>({
    noPermission: {
      id: 'packages.removeNoPermissionTooltip',
      defaultMessage: 'You do not have permission to remove a package.',
    },
  });
